import { Stack } from '@fluentui/react';
import React, { Component } from 'react';
import { ComboBoxDepartementAdministratif } from '../ComboBox/ComboBoxDepartementAdministratif';
import { IDS_NIVEAU } from '../ComboBox/ComboBoxNiveau';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation';
import { ComboBoxRegionAdministrative } from '../ComboBox/ComboBoxRegionAdministrative';
import { ComboBoxVilleAdministrative } from '../ComboBox/ComboBoxVilleAdministrative';
import { PickerPerimetre } from '../Picker/PickerPerimetre';

export class ComboBoxesPerimetreAdministratif extends Component {

    static defaultProps = {
        filtreSurMonPerimetre: true,
        idRegionAdministrative: 0,
        idDepartementAdministratif: "0",
        idVilleAdministrative: "0",
        idOperation: 0,
        onChange: (event, option, index, value, item, perimetre) => null,
        styles: {},
    };

    static defaultState = {
        regionsAdministratives: [],
        departementsAdministratifs: [],
        villesAdministratives: [],
        operations: [],
    };

    constructor(props) {
        super(props);
        this.state = { ...ComboBoxesPerimetreAdministratif.defaultState };
    };

    // KP - 15/06/2023 : ajout gestion de l'option par défaut
    _onChange = (event, option, index, value, item, idNiveau) => {
        const { onChange } = this.props;
        if (!!onChange && typeof onChange === "function") {
            let perimetre = {};
            if (Object.keys(item).length === 0) { // Sélection de l'option par défaut "Sélectionnez"
                switch (idNiveau) {
                    case IDS_NIVEAU.REGION_ADMINISTRATIVE: perimetre.idRegionAdministrative = ComboBoxesPerimetreAdministratif.defaultProps.idRegionAdministrative;
                    case IDS_NIVEAU.DEPARTEMENT_ADMINISTRATIF: perimetre.idDepartementAdministratif = ComboBoxesPerimetreAdministratif.defaultProps.idDepartementAdministratif;
                    case IDS_NIVEAU.VILLE_ADMINISTRATIVE: perimetre.idVilleAdministrative = ComboBoxesPerimetreAdministratif.defaultProps.idVilleAdministrative;
                    case IDS_NIVEAU.OPERATION: perimetre.idOperation = ComboBoxesPerimetreAdministratif.defaultProps.idOperation;
                    default: break;
                }
            }
            else {
                const { idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation } = item;
                perimetre = {
                    idRegionAdministrative: idRegionAdministrative || ComboBoxesPerimetreAdministratif.defaultProps.idRegionAdministrative,
                    idDepartementAdministratif: idDepartementAdministratif || ComboBoxesPerimetreAdministratif.defaultProps.idDepartementAdministratif,
                    idVilleAdministrative: idVilleAdministrative || ComboBoxesPerimetreAdministratif.defaultProps.idVilleAdministrative,
                    idOperation: idOperation || ComboBoxesPerimetreAdministratif.defaultProps.idOperation,
                };
            }
            onChange(event, option, index, value, item, perimetre);
        }
    };

    render = () => {

        const { filtreSurMonPerimetre, idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation, styles } = this.props;
        const { regionsAdministratives, departementsAdministratifs, villesAdministratives, operations } = this.state;

        return <Stack horizontal tokens={{ childrenGap: 8 }} styles={styles}>

            <Stack.Item grow={1}>
                <ComboBoxRegionAdministrative
                    filtreSurMonPerimetre={filtreSurMonPerimetre}
                    label=""
                    onChange={(event, option, index, value, item) => this._onChange(event, option, index, value, item, IDS_NIVEAU.REGION_ADMINISTRATIVE)}
                    onLoad={(selectedItem, newRegionsAdministratives) => { if (newRegionsAdministratives.length > regionsAdministratives.length) this.setState({ regionsAdministratives: newRegionsAdministratives }) }}
                    selectedKey={idRegionAdministrative}
                />
            </Stack.Item>
            <Stack.Item grow={1}>
                <ComboBoxDepartementAdministratif
                    filtreSurMonPerimetre={filtreSurMonPerimetre}
                    idRegionAdministrative={idRegionAdministrative}
                    idRegionAdministrativeRequired={false}
                    label=""
                    onChange={(event, option, index, value, item) => this._onChange(event, option, index, value, item, IDS_NIVEAU.DEPARTEMENT_ADMINISTRATIF)}
                    onLoad={(selectedItem, newDepartementsAdministratifs) => { if (newDepartementsAdministratifs.length > departementsAdministratifs.length) this.setState({ departementsAdministratifs: newDepartementsAdministratifs }) }}
                    selectedKey={idDepartementAdministratif}
                />
            </Stack.Item>
            <Stack.Item grow={1}>
                <ComboBoxVilleAdministrative
                    filtreSurMonPerimetre={filtreSurMonPerimetre}
                    idDepartementAdministratif={idDepartementAdministratif}
                    idDepartementAdministratifRequired={false}
                    idRegionAdministrative={idRegionAdministrative}
                    label=""
                    onChange={(event, option, index, value, item) => this._onChange(event, option, index, value, item, IDS_NIVEAU.VILLE_ADMINISTRATIVE)}
                    onLoad={(selectedItem, newVillesAdministratives) => { if (newVillesAdministratives.length > villesAdministratives.length) this.setState({ villesAdministratives: newVillesAdministratives }) }}
                    selectedKey={idVilleAdministrative}
                />
            </Stack.Item>
            <Stack.Item grow={1}>
                <ComboBoxOperation
                    filtreSurMonPerimetre={filtreSurMonPerimetre}
                    idDepartementAdministratif={idDepartementAdministratif}
                    idRegionAdministrative={idRegionAdministrative}
                    idVilleAdministrative={idVilleAdministrative}
                    idVilleAdministrativeRequired={false}
                    label=""
                    onChange={(event, option, index, value, item) => this._onChange(event, option, index, value, item, IDS_NIVEAU.OPERATION)}
                    onLoad={(selectedItem, newOperations) => { if (newOperations.length > operations.length) this.setState({ operations: newOperations }) }}
                    perimetre="administratif"
                    selectedKey={idOperation}
                />
            </Stack.Item>

            <PickerPerimetre
                accesPerimetreEiffage={false}
                onChange={(event, option, index, value) => this._onChange(event, option, index, value, option.data)}
                regionsAdministratives={regionsAdministratives}
                departementsAdministratifs={departementsAdministratifs}
                villesAdministratives={villesAdministratives}
                operations={operations}
            />

        </Stack>;

    };

};